import PropTypes from 'prop-types'

const PlayerGraph = (props) => {
  const { player, view, totalPlayed } = props

  const totalPlayingTime = player?.playingTime
  const totalSubstituteTime = player?.substitutionTime
  const totalAbsentTime = totalPlayed - (totalPlayingTime + totalSubstituteTime)

  const playingBarWidth = (100 / totalPlayed) * totalPlayingTime
  const substituteBarWidth = (100 / totalPlayed) * totalSubstituteTime
  const absentBarWidth = (100 / totalPlayed) * totalAbsentTime

  return (
    <>
      <div className="PlayerGraph">
        <div
          style={{ width: `${playingBarWidth}%` }}
          className={`PlayerGraph-bar ${totalPlayingTime !== 0 ? 'PlayerGraph-bar--playing' : ''} ${
            playingBarWidth < 21 ? 'not-padding' : ''
          }`}
        >
          {view === 'percentage' && playingBarWidth > 0 && (
            <span className="PlayerGraph-value">{Math.round(playingBarWidth)}%</span>
          )}
          {view === 'minutes' && totalPlayingTime !== 0 && (
            <span className="PlayerGraph-value">{totalPlayingTime}</span>
          )}
        </div>

        {totalSubstituteTime !== 0 && (
          <div
            style={{
              width: playingBarWidth !== 0 ? `calc(${substituteBarWidth}% + 20px)` : `${substituteBarWidth}%`
            }}
            className={`PlayerGraph-bar PlayerGraph-bar--substitute ${playingBarWidth !== 0 ? '' : 'is-zero'}`}
          >
            {view === 'percentage' && substituteBarWidth > 10 && (
              <span className="PlayerGraph-value">{Math.round(substituteBarWidth)}%</span>
            )}
            {view === 'minutes' && substituteBarWidth > 10 && (
              <span className="PlayerGraph-value">{totalSubstituteTime}</span>
            )}
          </div>
        )}
        {totalAbsentTime !== 0 && (
          <div
            style={{
              width: playingBarWidth !== 0 ? `calc(${absentBarWidth}% + 10px)` : `${absentBarWidth}%`
            }}
            className={`PlayerGraph-bar PlayerGraph-bar--absent`}
          >
            {view === 'percentage' && substituteBarWidth > 0 && (
              <span className="PlayerGraph-value">{Math.round(absentBarWidth)}%</span>
            )}
            {view === 'minutes' && absentBarWidth > 10 && <span className="PlayerGraph-value">{totalAbsentTime}</span>}
          </div>
        )}
      </div>
    </>
  )
}

PlayerGraph.defaultPropTypes = {
  player: {},
  view: 'minutes',
  totalPlayed: 0
}

PlayerGraph.propTypes = {
  totalPlayed: PropTypes.number,
  player: PropTypes.object,
  view: PropTypes.string
}

export default PlayerGraph
